import {
  jb_time_css_default
} from "./chunk.LGMTZJKD.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  D,
  ke,
  r
} from "./chunk.WKUNRGJV.js";
import {
  n
} from "./chunk.LWNTGWZJ.js";
import {
  __decorateClass
} from "./chunk.2QRLEY22.js";

// src/components/jb-time/jb-time.ts
var JbTime = class extends r {
  render() {
    return ke`<time>${this.time ? ke`<jb-clock-icon></jb-clock-icon><span>${this.time}</span>` : D}</time>`;
  }
};
JbTime.styles = jb_time_css_default;
__decorateClass([
  n()
], JbTime.prototype, "time", 2);
JbTime = __decorateClass([
  customElement("jb-time")
], JbTime);

export {
  JbTime
};
